import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Avatar, Button, CheckBox, SearchInput, Tab, Tabs } from "components";
import { useGetAllResources } from "controller";
import React, { useState } from "react";
import { getFullName } from "utilz/helpers";

export function SelectAssignees({
  setSelectedAssignees,
  selectedAssignees,
}: {
  selectedAssignees: Array<any>;
  setSelectedAssignees: (newAssignees: Array<any>) => void;
}) {
  const theme = useTheme();

  const { data: resources } = useGetAllResources({ filter: [] });
  const isAllSelected =
    resources?.result?.length > 0 &&
    selectedAssignees.length === resources?.result?.length;

  const onChange = (isSelected: boolean, data: any) => {
    if (isSelected) {
      return setSelectedAssignees([...selectedAssignees, data]);
    }
    return setSelectedAssignees(
      selectedAssignees.filter((id) => id !== data?.mapping_id),
    );
  };

  const onSelectAllChanged = (isSelected: boolean) => {
    if (isSelected) {
      return setSelectedAssignees(resources?.result ?? []);
    }
    return setSelectedAssignees([]);
  };

  return (
    <Stack
      sx={{
        bgcolor: "#FFFF",
        borderRadius: "8px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        minWidth: "400px",
      }}
    >
      <Stack sx={{ p: "24px", gap: "24px", overflow: "hidden" }}>
        <Typography variant="body-medium">Select Assignees</Typography>
        <SearchInput
          name={""}
          placeholder="Search"
          value={""}
          onChange={() => []}
          sx={{
            pt: "3px",
          }}
          hideHelperBox
        />
        {/* Resource component  */}
        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 12px 0px 12px",
            //   height: "100%",
          }}
        >
          <Typography variant="body-medium">Select All Resources</Typography>
          <CheckBox
            checked={isAllSelected}
            onChange={(_, isChecked) => onSelectAllChanged(isChecked)}
          />
        </Stack>
        <Stack
          gap="20px"
          sx={{
            flex: 1,
            overflowY: "auto",
            // maxHeight: "calc(100% - 10px)",
            maxHeight: "100%",
          }}
        >
          <Stack gap={"24px"}>
            {(Array.isArray(resources?.result) ? resources.result : []).map(
              (resource: any, index: number) => {
                const isSelected = Boolean(
                  selectedAssignees.find(
                    (selectedResource: any) =>
                      selectedResource?.mapping_id === resource?.mapping_id,
                  ),
                );
                return (
                  <Box key={index}>
                    <Stack
                      direction={"row"}
                      sx={{
                        justifyContent: "space-between",
                        padding: "0px 12px 0px 12px",
                        // backgroundColor: "red",
                      }}
                    >
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={2}
                      >
                        <Avatar
                          url={resource?.profile_image}
                          fullname={getFullName(
                            resource?.first_name,
                            resource?.middle_name,
                            resource?.last_name,
                          )}
                          variants={"lg"}
                        />
                        <Stack direction={"row"}>
                          <Typography
                            sx={{
                              width: "150px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              marginLeft: "-10px",
                            }}
                            variant="body-medium"
                          >
                            {getFullName(
                              resource?.first_name,
                              resource?.middle_name,
                              resource?.last_name,
                            )}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{
                          justifyContent: "center",
                        }}
                      >
                        <CheckBox
                          checked={isSelected}
                          onChange={(_, isChecked) =>
                            onChange(isChecked, resource)
                          }
                        />
                      </Stack>
                    </Stack>
                  </Box>
                );
              },
            )}
          </Stack>
        </Stack>
      </Stack>

      {/* footer */}
      {/* <Stack
        direction={"row"}
        gap="12px"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          borderTop: `.5px solid ${theme.palette.darkBg.medium}`,
          marginTop: "auto",
          padding: "10px 20px 10px 10px",
        }}
      >
        <Button
          variant="secondary"
          onClick={() => {
            selectAssigneeFuntion();
          }}
        >
          Cancel
        </Button>
        <Button>Proceedd</Button>
      </Stack> */}
    </Stack>
  );
}
